import React from 'react';
import BbaLogo from '../assets/images/bba_logo.png';

interface MainLogoProps {
  size: 'lg' | 'md' | 'sm',
}

const MainLogo: React.FC<MainLogoProps> = (props: MainLogoProps) => {
  const { size } = props;
  let heightForLogo = '60px';
  switch (size) {
    case ('lg'):
      heightForLogo = '60px';
      break;
    case ('md'):
      heightForLogo = '48px';
      break;
    case ('sm'):
      heightForLogo = '28px';
      break;
    default:
      break;
  }
  return (
    <img src={BbaLogo} alt="BBA" style={{ height: heightForLogo, width: 'auto' }} />
  );
};

export default MainLogo;
